<template>
	<ul>
		<li class="order-detail p-b">
		    <div class="link-wrap">
				<img src="@/assets/images/order-manage/ic_home_line_8.png" alt="" class="pt-img">
		        <span class="link">联系信息&nbsp;&nbsp;&nbsp;&nbsp;<span class="copy" @click.stop="utils.copyText('订单编号:'+detailList.order_code+',卖家旺旺:'+detailList.merchant_wangwang+',买家旺旺:'+detailList.consumer_wangwang)">一键复制</span></span>
		    </div>
			<div class="customer-info" v-for='(item,index) in detailList.question_url' :key='index' :class='{"no-h":!item}'>
				<span v-if="item" class="info-style" v-text='detailList.server_type==1?"商品链接":"商家网址"'></span>
				<span v-if="item" class="info-style limit-wth copy-s">{{item}}</span>
				<img src="@/assets/images/order-manage/ic_copy.png" alt="" class="copy-logo" @click="utils.copyText(item)"/>
			</div>
			<div v-if="detailList.server_type==1">
				<div class="customer-info">
				    <span class="info-style">卖家旺旺</span>
				    <span class="info-style limit-wth limit-wrap">{{detailList.merchant_wangwang}}</span>
				</div>
				<div class="customer-info">
				    <span class="info-style">买家旺旺</span>
				    <span class="info-style limit-wth limit-wrap">{{detailList.consumer_wangwang}}</span>
				</div>
			</div>
			<div v-else>
				<div class="customer-info">
				    <span class="info-style">顾客手机</span>
				    <span class="info-style limit-wth">{{detailList.consumer_mobile}}</span>
				</div>
				<div class="customer-info">
				    <span class="info-style">顾客姓名</span>
				    <span class="info-style limit-wth">{{detailList.consumer_name}}</span>
				</div>
			</div>
		</li>
		
		<li class="order-detail">
		    <div class="link-wrap">
				<img src="@/assets/images/order-manage/ic_home_line_5.png" alt="" class="pt-img">
		        <span class="link">截图信息</span>
		    </div>
		    <div class="img-list">
		        <img v-for="(item,index) in detailList.order_images" :key="index" :src="item" alt="" @click="handleImgsClick(detailList.order_images,index)" class="img-size" />
		    </div>
		</li>
	</ul>
</template>

<script>
	import utils from '@/assets/jslibs/utils'
    export default {
		data(){
			return{
				imgUrl:this.$store.state.imgUrl || sessionStorage.getItem("imgUrl"),
				utils
			}
		},
		
		props:{
			detailList:{
				type: Object,
			},
			
			operaRole:{
				type: String,
			}
		},
        name: 'ContractInfo',
		beforeUpdate(){
		    if(this.detailList.order_images && this.detailList.order_images.length){
		        this.detailList.order_images.forEach((item,index)=>{
					if(!item.includes("http") && !item.includes("https")){
						this.detailList.order_images[index] = this.imgUrl + this.detailList.order_images[index];
					}
		        })
		    }
		},
		
		methods:{
		    handleImgsClick(item,index) {
		    	this.initialIndex = index
		    	const params = {
		    		$props: {
		    			imgs: item,
		    			initialIndex: 'initialIndex', // 响应式数据的key名
		    			loop: false
		    		},
		    		$events: {
		    			change: (i) => {
		    				// 必须更新 initialIndex
		    				this.initialIndex = i
		    			}
		    		}
		    	}
		    	this.$createImagePreview({ ...params }).show()
		    } 
		}
    };
</script>
<style lang="less" scoped>
    @import '~@/assets/styles/variable.less';
    @import '~@/assets/styles/handleMethods.less';
    @import '~@/assets/styles/reset.css';
	section{font-family:PingFangSC-Regular;font-weight:400;background:#F5F5F5}
    // .order-content{margin:10px 10px 0 10px;}
	.order-detail{margin-bottom: 10px;background: #fff}
	.link-wrap{font-size: 0;height: 1.38666667rem;margin: 0 15px;line-height: 1.38666667rem;border-bottom: 0.026667rem solid #EEEEEE;}
	.link{display: inline-block;vertical-align: middle;color:rgba(20,20,20,1);font-size: 15px;font-family: PingFangSC-Semibold,PingFang SC;font-weight: 600;color: rgba(51,51,51,1);}
	.pt-img{height: 20px;margin-right: 8px;display: inline-block;vertical-align:middle}
	.customer-info{padding: 10px 15px 2px 15px;display: -webkit-box;display: -ms-flexbox;display: flex;justify-content: space-between;align-items: center;flex-wrap: wrap}
	.info-style{color:rgba(74,74,74,1);font-size: 14px}
	.p-b{padding-bottom:8px}
	.limit-wrap{margin-right: 0.213333rem; white-space: nowrap;text-overflow: ellipsis;overflow: hidden;flex: 1; margin-right: 0.213333rem;margin-left: 0.64rem;text-align: right;}
	.no-h{padding: 0;}
	
	.img-list{display: -webkit-box;display: -ms-flexbox;display: flex;flex-wrap: wrap;padding:15px 17.5px}
	.img-size{width: 95px;height:95px;margin-right: 16px;margin-bottom: 7.5px}
	.img-list .img-size:nth-child(3n){margin-right: 0}
	.copy-logo{width: 12px;height: 12px}
	.copy-s{margin-left: 0.64rem;flex: 1;text-align: right;margin-right: 0.213333rem;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;}
	.copy{font-size: 12px;font-family: PingFangSC-Regular,PingFang SC;font-weight: 400;color: rgba(174,174,174,1);padding: 1px 5px;border-radius: 1px; border: 1px solid rgba(193,193,193,1);}
	
</style>
